(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-additions-components/assets/javascripts/sportkryss/sportkryss-number-area.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-additions-components/assets/javascripts/sportkryss/sportkryss-number-area.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactBadge = _svs$ui.ReactBadge;
const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Input = _svs$ui$reactForm.Input;
const actions = svs.components.tipsen.engine.actions;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSportkryssNumber = _svs$components$tipse.selectSportkryssNumber,
  selectCurrentSportkryssFactor = _svs$components$tipse.selectCurrentSportkryssFactor;
const generateSportkryssNumber = svs.components.tipsen.engine.utils.generateSportkryssNumber;
const SPORTKRYSS_SIZE = svs.components.tipsen.engine.constants.SPORTKRYSS_SIZE;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const SportkryssNumberArea = () => {
  const couponId = useCouponId();
  const dispatch = useDispatch();
  const currentSportkryssFactor = useSelector(state => selectCurrentSportkryssFactor(state, couponId));
  const currentSportkryssNumber = useSelector(state => selectSportkryssNumber(state, couponId));
  const presentationRef = useRef();
  const inputRef = useRef();
  const _useState = useState({
      editing: false,
      inputNumber: currentSportkryssNumber
    }),
    _useState2 = _slicedToArray(_useState, 2),
    inputState = _useState2[0],
    setInputState = _useState2[1];
  useEffect(() => {
    document.documentElement.style.setProperty('--sportkryss-size', SPORTKRYSS_SIZE);
  }, []);

  useEffect(() => {
    if (currentSportkryssNumber) {
      setInputState(currentInputState => _objectSpread(_objectSpread({}, currentInputState), {}, {
        inputNumber: currentSportkryssNumber
      }));
    }
  }, [currentSportkryssNumber]);
  const submitSportkryssInput = useCallback(() => {
    setInputState(currentInputState => _objectSpread(_objectSpread({}, currentInputState), {}, {
      editing: false
    }));
    if (inputState.inputNumber.length > 0) {
      dispatch(actions.setSportkryssNumber({
        couponId,
        sportkryssNumber: generateSportkryssNumber(inputState.inputNumber)
      }));
    }
  }, [couponId, dispatch, inputState.inputNumber]);
  const onSportkryssClick = () => {
    if (!currentSportkryssFactor) {
      return;
    }
    if (!inputState.editing) {
      setInputState(_objectSpread(_objectSpread({}, inputState), {}, {
        editing: true,
        inputNumber: currentSportkryssNumber
      }));
      inputRef.current.focus();
      inputRef.current.select();
    }
  };
  const onSportkryssInputBlur = () => {
    submitSportkryssInput();
  };
  const onSportkryssKeyDown = event => {
    const key = event.key,
      keyCode = event.keyCode;
    if (key === 'Enter' || keyCode === 13) {
      event.preventDefault();
      event.target.blur();
    }
  };
  const onSportkryssInputChange = _ref => {
    let target = _ref.target;
    const regexp = /^[0-9\b]+$/;
    const valueIsValid = regexp.test(target.value);
    if (target.value === '' || valueIsValid) {
      setInputState(_objectSpread(_objectSpread({}, inputState), {}, {
        inputNumber: target.value
      }));
    }
  };
  const generateNewSportkryssNumber = useCallback(() => {
    const sportkryssNumber = generateSportkryssNumber();
    dispatch(actions.setSportkryssNumber({
      couponId,
      sportkryssNumber
    }));
    setInputState(current => _objectSpread(_objectSpread({}, current), {}, {
      inputNumber: sportkryssNumber
    }));
  }, [couponId, dispatch]);
  const numberContainerClassList = ['number-container'];
  !currentSportkryssFactor && numberContainerClassList.push('disabled');
  return React.createElement("div", {
    className: "sportkryss-number-area"
  }, React.createElement("div", {
    className: numberContainerClassList.join(' ')
  }, React.createElement("div", {
    className: "number-presentation".concat(inputState.editing ? ' hidden' : ''),
    "data-testid": "number-presentation-wrapper",
    onClick: onSportkryssClick,
    ref: presentationRef
  }, Array.from(currentSportkryssNumber).map((num, index) => {
    const key = "".concat(index, "_").concat(num);
    return React.createElement("span", {
      key: key
    }, React.createElement(ReactBadge, {
      className: "number-integer badge-bounce ".concat(!currentSportkryssFactor ? 'disabled' : '')
    }, num));
  })), React.createElement("div", {
    className: "number-input".concat(inputState.editing ? '' : ' hidden'),
    "data-testid": "number-input-wrapper"
  }, React.createElement(ControlGroup, null, React.createElement(Input, {
    "aria-label": "Sportkryssnummer",
    autoComplete: "off",
    disabled: !currentSportkryssFactor,
    maxLength: SPORTKRYSS_SIZE,
    onBlur: onSportkryssInputBlur,
    onChange: onSportkryssInputChange,
    onFocus: onSportkryssClick,
    onKeyDown: onSportkryssKeyDown,
    refElem: inputRef,
    type: "tel",
    value: inputState.inputNumber
  })))), React.createElement(ReactButton, {
    "aria-label": "Slumpa nytt Sportkryssnummer",
    block: true,
    "data-testid": "sportkryss-button",
    disabled: !currentSportkryssFactor,
    onClick: generateNewSportkryssNumber,
    size: 300,
    transparent: true
  }, "Slumpa"));
};
setGlobal('svs.components.tipsen.couponAdditionsComponents.sportkryss.SportkryssNumberArea', SportkryssNumberArea);

 })(window);